import React from "react";

import { Box } from "@chakra-ui/react";

import { Paragraph3 } from "ui/typography";

import { BusinessDetailsDirectorInformation } from "./BusinessDetailsDirectorInformation";
import { IBusinessDetailsDirectorsInformationProps } from "./types";

const START_INDEX = 0;
const INDEX_OFFSET = 1;

export const BusinessDetailsDirectorsInformation = (
  props: IBusinessDetailsDirectorsInformationProps
) => {
  const { business, isContentWrapperBelow745, isContentWrapperBelow600 } =
    props;

  const businessDirectors =
    business?.business?.companyData?.businessDirectors || [];

  return (
    <Box>
      <Box className="flex flex-col gap-4">
        {businessDirectors.length > START_INDEX ? (
          businessDirectors.map((businessDirector, index) => (
            <BusinessDetailsDirectorInformation
              key={index}
              businessDirector={businessDirector}
              isContentWrapperBelow745={isContentWrapperBelow745}
              isContentWrapperBelow600={isContentWrapperBelow600}
              position={index + INDEX_OFFSET}
              business={business}
            />
          ))
        ) : (
          <Box>
            <Paragraph3
              lineHeight="22.4px"
              textColor="#718096"
            >
              No Business Directors
            </Paragraph3>
          </Box>
        )}
      </Box>
    </Box>
  );
};
